import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';

import VueSlider from 'vue-slider-component';
import VueJsonLD from 'vue-jsonld';
import VueMeta from 'vue-meta';
import MQ from 'vue-match-media';
import VueAB from 'vue-a2b';
import { InlineSvgPlugin } from 'vue-inline-svg';
import VueContentPlaceholders from 'vue-content-placeholders';

Vue.config.productionTip = false;
Vue.prototype.$cdnBaseUrl = process.env.VUE_APP_CDN_URL;
Vue.prototype.$prodBaseUrl = 'https://componata.de';

Vue.component('VueSlider', VueSlider);

Vue.use(VueLodash, { lodash: lodash });

Vue.use(VueJsonLD);

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.use(MQ);

Vue.use(VueAB, {
  component: 'a-b',
  storage: {
    name: 'abt',
    method: 'cookie'
  }
});

Vue.use(InlineSvgPlugin);
Vue.use(VueContentPlaceholders);

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#spa-shop');
